/*
 * @Author: heshouzhi heshouzhi@millionlab.cn
 * @Date: 2024-05-17 18:05:06
 * @LastEditors: heshouzhi heshouzhi@millionlab.cn
 * @LastEditTime: 2024-05-20 19:08:29
 * @FilePath: /web-crm/src/pages/report/member_order_analysis/models/memberOrderAnalysis.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import * as memberOrderAnalysis from '../services/memberOrderAnalysis';

export default {
  namespace: 'memberOrderAnalysis',

  state: {
    userInfo: null,
    memberPageList: null,
    addMember: null,
    levels: [],
    allTotal: 0,
  },

  effects: {
    *queryMemberOrderInfo({ payload: { values } }, { call, put }) {
      const response = yield call(
        memberOrderAnalysis.queryMemberOrderInfo,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          memberPageList: response?.data,
          allTotal: response?.data?.total,
        },
      });
    },
    *queryMemberOrderInfoPageNum({ payload: { values } }, { call, put }) {
      const response = yield call(
        memberOrderAnalysis.queryMemberOrderInfo,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          allTotal: response?.data?.total,
        },
      });
    },
    //导出
    *exportMemberOrderInfo({ payload: { values }, callback }, { call }) {
      const response = yield call(
        memberOrderAnalysis.exportMemberOrderInfo,
        values,
      );
      callback(response);
    },

    // 获取门店树形列表
    *getStoreTreeList(_, { call, put }) {
      const response = yield call(memberOrderAnalysis.getStoreTreeList);
      yield put({
        type: 'save',
        payload: {
          storeTreeList: response.data,
        },
      });
    },
    // 获取门店树形列表
    *getStoreAndArea(_, { call, put }) {
      const createId = () => {
        return Math.random().toString(36).substr(2, 10);
      };
      const response = yield call(memberOrderAnalysis.getStoreAndArea);
      const array = response.data ?? [];
      const newArrayArea = array.map((item) => {
        const id = createId();
        const children = (item.userStoreList ?? []).map((i) => {
          i.parentId = id;
          return { ...i, parentId: item.userSalesArea };
        });
        const areaObj = {
          name: item.userSalesArea,
          id: item.userSalesArea,
          children,
        };
        return areaObj;
      });
      const areasList = array.map((item) => ({
        name: item.userSalesArea,
        id: item.userSalesArea,
      }));
      yield put({
        type: 'save',
        payload: {
          storeAndArea: newArrayArea,
          areasList: areasList,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
